module.exports = __webpack_public_path__ + "img/change_time_setting-en-US.28556ca1.png";